import { Button, Flex, Text } from '@chakra-ui/react'
import { Trans } from '@lingui/react/macro'
import { type FC, useEffect } from 'react'
import { FaMagic } from 'react-icons/fa'

import { logEvents } from './logEvents'

type DisabledReasonLayout = 'below' | 'left'

type Props = {
  isLoading: boolean
  isDisabled: boolean
  onClick: () => void
  reason: string
  disabledReasonLayout?: DisabledReasonLayout
}

export const LiveSummaryButton: FC<Props> = ({
  isDisabled,
  isLoading,
  onClick,
  reason,
  disabledReasonLayout = 'below',
}) => {
  const hasDisabledReason = isDisabled && reason !== ''

  //This is only used for debugging, sometimes the button doesn't render
  useEffect(() => {
    logEvents({
      eventType: 'eventRenderLiveSummaryButton',
      reason,
      isDisabled,
    })
  }, [reason, isDisabled])

  const button = (
    <Button
      isDisabled={hasDisabledReason}
      leftIcon={<FaMagic />}
      size="xs"
      colorScheme="primary"
      isLoading={isLoading}
      onClick={onClick}
    >
      <Trans>Summarize conversation</Trans>
    </Button>
  )

  if (hasDisabledReason && disabledReasonLayout === 'left') {
    return (
      <Flex direction="row" alignItems="center" gap="2">
        <Text
          fontSize="xs"
          color="gray.600"
          textAlign="right"
          noOfLines={2}
          maxW="220px"
        >
          {reason}
        </Text>
        {button}
      </Flex>
    )
  }

  return (
    <Flex direction="column" alignItems="flex-start" gap="1">
      {button}
      {hasDisabledReason && (
        <Text fontSize="xs" color="gray.600" noOfLines={2} maxW="100%">
          {reason}
        </Text>
      )}
    </Flex>
  )
}
